import { SessionChip } from "../../features/auth/SessionChip.tsx";
import { SearchBox } from "../../features/search/SearchBox.tsx";
import { Link } from "../router.ts";
import type { RouteLabel } from "../routes.ts";
import { AsOfBadge } from "./AsOfBadge.tsx";
import s from "./shell.module.css";

/** The top bar. It owns NO data: the freshness badge reads the head store and the search box is a
 *  navigation. A shell that fetches is a shell every screen has to wait for. */
export function TopBar({ active }: { active: RouteLabel }) {
  return (
    <header className={s.topbar}>
      <Link to="#/board" className={s.brand}>
        kinetiq
      </Link>
      <nav className={s.nav}>
        <Link to="#/board" className={active === "board" ? s.navActive : undefined}>
          board
        </Link>
        {/* A DIFFERENT POPULATION, NOT A VIEW OF THE BOARD — mints whose BIRTH we witnessed, against mints
            that have TRADED — which is why it is a sibling entry rather than a control on the board. */}
        <Link to="#/launches" className={active === "launches" ? s.navActive : undefined}>
          launches
        </Link>
        <Link to="#/wallet" className={active === "wallet" ? s.navActive : undefined}>
          wallet
        </Link>
      </nav>
      {/* ONE BOX FOR BOTH QUESTIONS. It replaced a paste-an-address box that deliberately refused names,
          because until 2026-08-13 there was no `/v1/search` behind one — a box that accepted "bonk" and
          returned nothing would have reported a missing SUBSYSTEM as an empty result. The route exists now,
          and a second input beside the first would have left the bar with two boxes that both look like
          search. The address destination survives inside it: a pasted address still offers the WALLET page,
          which no search route can decide for you. */}
      <SearchBox />
      <div className={s.spacer} />
      <AsOfBadge />
      {/* THE SESSION CONTROL. It renders itself away entirely when the server reports `enabled:false` — a
          disabled "Connect wallet" that does nothing is indistinguishable from one that is broken — and it
          keeps rendering when the config read merely FAILED, because everything in it except sign-in is local
          state and hiding it on an unreachable server is how a whole wallet menu once vanished during a
          restart and stayed gone until a manual reload. */}
      <SessionChip />
    </header>
  );
}
